import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { BreadCrumbService } from '../../../@vex/components/breadcrumbs/BreadCrumbService';
import { Icons } from '../../util/Icons';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { MatAnchor } from '@angular/material/button';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { BreadcrumbsComponent } from '../../../@vex/components/breadcrumbs/breadcrumbs.component';
import { ContainerDirective } from '../../../@vex/directives/container/container.directive';
import { SessionService } from '../../services/session.service';

@Component({
	selector: 'vex-support-araapp',
	imports: [
		TranslocoDirective,
		PageLayoutComponent,
		PageLayoutHeaderDirective,
		PageLayoutContentDirective,
		BreadcrumbsComponent,
		MatExpansionModule,
		MatIconModule,
		RouterModule,
		ContainerDirective,
		MatAnchor,
	],
	templateUrl: './support-araapp.component.html',
	styleUrl: './support-araapp.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [stagger40ms],
})
export class SupportAraappComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly translocoService = inject(TranslocoService);

	protected readonly breadCrumbService = inject(BreadCrumbService);
	protected readonly icons = inject(Icons);
	protected readonly sessionService = inject(SessionService);

	ngOnInit(): void {
		this.translocoService
			.selectTranslate('supportAraApp.title')
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.breadCrumbService.reset();
				this.breadCrumbService.addBreadCrumb({
					translationKey: 'supportAraApp.title',
					icon: this.icons.get('help'),
				});
			});
	}
}
